module.exports = __webpack_public_path__ + "a8c874b93b3d848f39a71260c57e3863.cur";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img/grabbing.cur
 ** module id = 708
 ** module chunks = 0
 **/